(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(function(){var u=new URL(window.location.href);if(u.hash){document.addEventListener('DOMContentLoaded',function(){var c=document.getElementById(u.hash.slice(1));if(c){c.scrollIntoView({behavior:'instant'})}},{once:true})}})();

  } catch(e) { console.error(e); }
})();
})();
